import {
  Box,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  CardActions,
} from "@material-ui/core";
import axios from "axios";
import React, { Fragment, useState } from "react";
import { UsersData } from "src/ContextAPI";
import Notify from "src/notification/Notify";
import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons";

const DocuPatientDetailsLabJabeliFecal = ({
  selectedBranch,
  patient_id,
  getStoolTest,
  details,
  medTechList,
  updatePatientList,
}) => {
  const { users } = React.useContext(UsersData);
  const [savebtnStoolDisabled, setSavebtnStoolDisabled] = useState(false);
  const [microscopic, setMicroscopy] = useState({
    dfs: false,
    kt: false,
    kk: false,
  });

  const handleSaveStoolResult = (e) => {
    e.preventDefault();
    e.persist();
    var formdata = new FormData(e.target);
    formdata.set("user_id", users.user_id);
    formdata.set("patient_id", patient_id);
    formdata.set("dfs", microscopic.dfs ? 1 : 0);
    formdata.set("kt", microscopic.kt ? 1 : 0);
    formdata.set("kk", microscopic.kk ? 1 : 0);

    var error = [];
    if (
      formdata.get("medtech").length === 0 ||
      formdata.get("medtech").trim() === ""
    ) {
      error = "error";
      Notify.fieldRequired("Medical Technologist");
    }
    if (error.length > 0) {
      console.log("Form has an error.");
    } else {
      setSavebtnStoolDisabled(true);
      axios
        .post("van/order/ordernew-stool/save-process-result", formdata)
        .then((response) => {
          const data = response.data;
          if (data === "success") {
            getStoolTest();
            updatePatientList();
            Notify.successRequest("order result added.");
          }
        })
        .catch((error) => {
          Notify.requestError(error);
        })
        .finally(() => {
          setSavebtnStoolDisabled(false);
        });
    }
  };

  React.useEffect(() => {}, [patient_id]);

  return (
    <Fragment>
      <form onSubmit={handleSaveStoolResult}>
        <Card elevation={0}>
          {details && (
            <Fragment>
              <CardContent>
                <Box hidden={!Boolean(parseInt(details.fecalysis))}>
                  <Box>
                    <Box>
                      <TextField
                        margin="dense"
                        fullWidth
                        name="order_id[]"
                        label="order_id"
                        value={details.order_id}
                        hidden
                      />
                      <TextField
                        margin="dense"
                        fullWidth
                        name="patient_id"
                        label="patient_id"
                        value={details.patient_id}
                        hidden
                      />

                      <TextField
                        margin="dense"
                        fullWidth
                        name="doctors_id"
                        label="doctor_id"
                        value={
                          details.doctor_id === null ? "" : details.doctor_id
                        }
                        hidden
                      />
                    </Box>

                    <Box>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <Box>
                            <TextField label="Color" name="color[]" fullWidth />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Box>
                            <TextField
                              label="Consistency"
                              name="consistency[]"
                              fullWidth
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Box>
                            <TextField
                              label="Occult Blood"
                              name="occult_blood[]"
                              fullWidth
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Box mt={2}>
                            <Typography>
                              <strong> Microscopy </strong>
                            </Typography>
                          </Box>

                          <Box mt={3}>
                            <Typography>Ascaris Lumbricoides:</Typography>
                          </Box>

                          <Box>
                            <Typography> Hookworm: </Typography>
                          </Box>

                          <Box mt={2}>
                            <Typography>Blastocystis Hominis:</Typography>
                          </Box>

                          <Box mt={2.1}>
                            <Typography>
                              <strong> Giardia Lamblia </strong>
                            </Typography>
                          </Box>

                          <Box>
                            <Typography align="right"> Cyst: </Typography>
                          </Box>

                          <Box mt={1}>
                            <Typography align="right">Trophozoite:</Typography>
                          </Box>

                          <Box mt={1}>
                            <Typography> Trichuris Trichiura </Typography>
                          </Box>

                          <Box mt={1.3}>
                            <Typography>
                              <strong> Entamoeba Histolytica </strong>
                            </Typography>
                          </Box>

                          <Box mt={2}>
                            <Typography align="right"> Cyst: </Typography>
                          </Box>

                          <Box mt={1}>
                            <Typography align="right">Trophozoite:</Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                          <Box align="center">
                            {microscopic.dfs ? (
                              <IconButton
                                onClick={() =>
                                  setMicroscopy({
                                    ...microscopic,
                                    dfs: false,
                                  })
                                }
                              >
                                <CheckBox color="primary" />
                              </IconButton>
                            ) : (
                              <IconButton
                                onClick={() =>
                                  setMicroscopy({
                                    ...microscopic,
                                    dfs: true,
                                  })
                                }
                              >
                                <CheckBoxOutlineBlank />
                              </IconButton>
                            )}
                            Direct Fecal Smear
                          </Box>

                          <Box>
                            <TextField
                              InputProps={{ disabled: !microscopic.dfs }}
                              label=""
                              name="dfs_ascaris[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              InputProps={{ disabled: !microscopic.dfs }}
                              label=""
                              name="dfs_hookworm[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              InputProps={{ disabled: !microscopic.dfs }}
                              label=""
                              name="dfs_blasto[]"
                              fullWidth
                            />
                          </Box>

                          <Box mt={4}>
                            <TextField
                              InputProps={{ disabled: !microscopic.dfs }}
                              label=""
                              name="dfs_giadia_cyst[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              InputProps={{ disabled: !microscopic.dfs }}
                              label=""
                              name="dfs_giadia_trophozoite[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              InputProps={{ disabled: !microscopic.dfs }}
                              label=""
                              name="dfs_trichuris[]"
                              fullWidth
                            />
                          </Box>

                          <Box mt={4}>
                            <TextField
                              InputProps={{ disabled: !microscopic.dfs }}
                              label=""
                              name="dfs_estamoeba_cyst[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              InputProps={{ disabled: !microscopic.dfs }}
                              label=""
                              name="dfs_estamoeba_trophozoite[]"
                              fullWidth
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                          <Box>
                            {microscopic.kt ? (
                              <IconButton
                                onClick={() =>
                                  setMicroscopy({
                                    ...microscopic,
                                    kt: false,
                                  })
                                }
                              >
                                <CheckBox color="primary" />
                              </IconButton>
                            ) : (
                              <IconButton
                                onClick={() =>
                                  setMicroscopy({
                                    ...microscopic,
                                    kt: true,
                                  })
                                }
                              >
                                <CheckBoxOutlineBlank />
                              </IconButton>
                            )}
                            Kato-Thick
                          </Box>

                          <Box>
                            <TextField
                              label=""
                              disabled={!microscopic.kt}
                              name="kt_ascaris[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              label=""
                              disabled={!microscopic.kt}
                              name="kt_hookworm[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              label=""
                              disabled={!microscopic.kt}
                              name="kt_blasto[]"
                              fullWidth
                            />
                          </Box>

                          <Box mt={4}>
                            <TextField
                              label=""
                              disabled={!microscopic.kt}
                              name="kt_giadia_cyst[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              label=""
                              disabled={!microscopic.kt}
                              name="kt_giadia_trophozoite[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              label=""
                              disabled={!microscopic.kt}
                              name="kt_trichuris[]"
                              fullWidth
                            />
                          </Box>

                          <Box mt={4}>
                            <TextField
                              label=""
                              disabled={!microscopic.kt}
                              name="kt_estamoeba_cyst[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              label=""
                              disabled={!microscopic.kt}
                              name="kt_estamoeba_trophozoite[]"
                              fullWidth
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                          <Box>
                            {microscopic.kk ? (
                              <IconButton
                                onClick={() =>
                                  setMicroscopy({
                                    ...microscopic,
                                    kk: false,
                                  })
                                }
                              >
                                <CheckBox color="primary" />
                              </IconButton>
                            ) : (
                              <IconButton
                                onClick={() =>
                                  setMicroscopy({
                                    ...microscopic,
                                    kk: true,
                                  })
                                }
                              >
                                <CheckBoxOutlineBlank />
                              </IconButton>
                            )}
                            Kato-Katz
                          </Box>

                          <Box align="center">
                            <TextField
                              disabled={!microscopic.kk}
                              label=""
                              name="kk_ascaris[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              disabled={!microscopic.kk}
                              label=""
                              name="kk_hookworm[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              disabled={!microscopic.kk}
                              label=""
                              name="kk_blasto[]"
                              fullWidth
                            />
                          </Box>

                          <Box mt={4}>
                            <TextField
                              disabled={!microscopic.kk}
                              label=""
                              name="kk_giadia_cyst[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              disabled={!microscopic.kk}
                              label=""
                              name="kk_giadia_trophozoite[]"
                              fullWidth
                            />
                          </Box>
                          <Box>
                            <TextField
                              disabled={!microscopic.kk}
                              label=""
                              name="kk_trichuris[]"
                              fullWidth
                            />
                          </Box>
                          <Box mt={4}>
                            <TextField
                              disabled={!microscopic.kk}
                              label=""
                              name="kk_estamoeba_cyst[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              disabled={!microscopic.kk}
                              label=""
                              name="kk_estamoeba_trophozoite[]"
                              fullWidth
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box>
                      <TextField
                        label="Other"
                        name="others[]"
                        multiline
                        fullWidth
                      />
                    </Box>

                    <Box>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <Box>
                            <TextField
                              label="Pus Cells"
                              name="pus_cells[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              label="Red Blood Cells"
                              name="rbc[]"
                              fullWidth
                            />
                          </Box>

                          <Box>
                            <TextField
                              label="Fat Globules"
                              name="fat_globules[]"
                              fullWidth
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Box>
                            <TextField
                              label="Yeast Cells"
                              name="yeast_cells[]"
                              fullWidth
                            />
                          </Box>
                          <Box>
                            <TextField
                              label="Bacteria"
                              name="bacteria[]"
                              fullWidth
                            />
                          </Box>
                          <Box>
                            <TextField
                              label="Oil Droplets"
                              name="oil_droplets[]"
                              fullWidth
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Box>
                            <TextField
                              label="Undigested Food Particles"
                              name="undigested_food[]"
                              fullWidth
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box>
                      <TextField
                        label="Remarks (Note: this remarks will be added in our clinical summary)"
                        name="remarks[]"
                        multiline
                        fullWidth
                      />
                    </Box>

                    <Box>
                      <TextField
                        select
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        required
                        name="medtech"
                        label="MedTech"
                      >
                        <option value={""}> Select </option>
                        {medTechList.data.length > 0 ? (
                          medTechList.data.map((data, index) => (
                            <option key={index} value={data.user_id}>
                              {data.name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No medical technologist found.
                          </option>
                        )}
                      </TextField>
                    </Box>
                  </Box>
                </Box>
              </CardContent>
              <Box display="flex" m={1}>
                <Box flexGrow={1} />
                <Box>
                  <CardActions>
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      type="submit"
                      disabled={savebtnStoolDisabled}
                    >
                      Save Result
                    </Button>
                  </CardActions>
                </Box>
              </Box>
            </Fragment>
          )}
        </Card>
      </form>
    </Fragment>
  );
};

export default DocuPatientDetailsLabJabeliFecal;
